export const teamData = [
  {
    name: "Salman Zare",
    description:
      "Technical Leader with 20 years of experience across roles like CTO, Engineering Lead, and Product Owner. Expert in building scalable systems, leading engineering teams, and aligning technology with business goals. Passionate about mentoring teams, driving digital transformation, and delivering high-quality, innovative software solutions.",
    image: "/team/Salman-anime.webp",
    position: "CEO & Co-Founder",
  },
  {
    name: "Ahmad Behzadi",
    description:
      "Product Designer passionate about creating user-driven solutions across Tech, SaaS, Healthcare, Retail, Finance, and Blockchain  industries. Skilled at aligning design with business goals, collaborating with clients and development teams, and delivering seamless, engaging digital experiences that combine creativity, functionality, and impact.",
    image: "/team/Ahmad-anime.webp",
    position: "Product Designer & Co-Founder",
  },
  {
    name: "Ramin Akhtar",
    description:
      "Machine Learning Engineer and Data Scientist with 6+ years of experience in NLP, computer vision, and real-time motion capture. Expert in Python, C++, TensorFlow, and cloud computing. Passionate about solving complex problems, optimizing AI models, and pushing the boundaries of deep learning and real-world AI applications.",
    image: "/team/Ramin.webp",
    position: "Senior AI and ML Data Scientist",
  },
  {
    name: "Abbas Moeini",
    description:
      "DevOps Engineer with 5 years of experience designing, implementing, and managing cloud infrastructure and CI/CD pipelines. Expert in AWS, Terraform, and automation tools, security, and cost-efficiency. Also experienced in technical leadership, team management, and providing accurate project estimates to achieve development goals.",
    image: "/team/Abbas.webp",
    position: "DevOps & Technical Lead",
  },
  {
    name: "Ehsan Masoumi",
    description:
      "Product Designer with 4+ years of experience creating user-centered, visually appealing digital products. Specializes in improving usability, engagement, and accessibility through intuitive design. Dedicated to solving real-world problems and enhancing everyday digital interactions with creativity and strategic thinking.",
    image: "/team/Ehsan.webp",
    position: "Senior Product and UI/UX Designer",
  },
  {
    name: "Mahboubeh Omidi",
    description:
      "Project Manager with over 5 years of experience leading software and digital projects. Skilled in Agile and Scrum methodologies, optimizing workflows, and managing cross-functional teams. Focused on driving collaboration, meeting project goals, and delivering high-quality solutions that align with business objectives.",
    image: "/team/Mahboubeh.webp",
    position: "Project Manager",
  },
  {
    name: "Zabih Atashbarg",
    description:
      "Full-stack Developer with 10+ years of experience specializing in AI, IoT, and mobile development. Skilled in Python, Node.js, React.js, and app development for Android and iOS. Focused on building scalable applications, integrating AI data pipelines, and delivering high-performance, real-world technology solutions.",
    image: "/team/Zabih.webp",
    position: "Senior Fullstack Developer",
  },
  {
    name: "Elahe Nikseresht",
    description:
      "Backend Developer with 4+ years of experience building scalable backend systems using Nest.js, TypeScript, PostgreSQL, and MongoDB. Led backend development for major platforms, with a strong focus on writing clean code, improving system performance, and driving product success through robust architecture.",
    image: "/team/Elahe.webp",
    position: "Senior Backend Developer",
  },
  {
    name: "Yaser Sharifi",
    description:
      "Frontend Developer with expertise in JavaScript, TypeScript, React.js, Next.js, Tailwind CSS, and Material UI. Skilled in developing responsive web apps and mobile applications using Flutter. Focused on delivering intuitive, seamless user experiences across platforms and enhancing digital product performance.",
    image: "/team/Yaser.webp",
    position: "Senior Fullstack Developer",
  },
  {
    name: "Saghar Meftah",
    description:
      "Frontend Developer with 5 years of experience designing and building responsive, user-friendly web applications. Proficient in HTML, CSS, JavaScript, React.js, Next.js, and Angular. Focused on solving real-world problems through clean, efficient interfaces and enhancing overall digital user experiences.",
    image: "/team/Saghar.webp",
    position: "Senior Frontend Developer",
  },
  {
    name: "Hamed Ahmadi",
    description:
      "Frontend Developer with 3+ years of experience creating efficient and responsive web applications. Skilled in HTML, CSS, JavaScript, React.js, and Next.js. Passionate about delivering clean, user-centered designs that improve functionality, usability, and engagement across a variety of digital platforms.",
    image: "/team/Hamed.webp",
    position: "Senior Frontend Developer",
  },
  {
    name: "Mahdi Sadrpour",
    description:
      "Unreal Engine Developer with expertise in C++ and Blueprints. Skilled in building gameplay systems, tools, level design, visual effects, animation, and AI. Focused on performance optimization to create smooth, immersive experiences that push creative and technical boundaries in gaming and interactive environments.",
    image: "/team/MahdiS.webp",
    position: "Senior Game Developer",
  },
  {
    name: "Mahdi Khazraee",
    description:
      "Content Writer and YouTuber with a Master’s in Cultural Studies. Specializes in creating blog articles and engaging video content. Passionate about storytelling, creativity, and making complex ideas accessible through different media, bringing a fresh, artistic touch to every project.",
    image: "/team/MahdiK.webp",
    position: "Content Creator and Artist ",
  },

  {
    name: "S. Javad Falsafi",
    description:
      "An experienced technical man with more than 20 years of experties in software development. He participates in decision making sessions with our partners and the design team to ensure they go with the best possible solution to meet the project’s goals.",
    image: "/team/Javad.webp",
    position: "CFO & HR ",
  },
];
